import { Navigate, Outlet, useLocation } from 'react-router';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/auth-context';

function LoadingSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, sessionError, refreshProfile, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    if (sessionError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <p role="alert" className="max-w-md text-sm text-red-600">
            {sessionError}
          </p>
          <Button onClick={() => void refreshProfile()}>Tentar novamente</Button>
        </div>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to set-password if user has temporary password
  if (user?.temporaryPassword && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }

  return <Outlet />;
}
